import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  MenuItem,
  Box,
  CircularProgress,
  IconButton,
  Snackbar,
  Alert
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { investorApi, vendorApi } from "../../api/api";

const EditApartmentModal = ({ open, onClose, apartmentId, onUpdated }) => {
  const [loading, setLoading] = useState(false);

  console.log(apartmentId);
  debugger
  const [form, setForm] = useState({
    ApartmentName: "",
    City: "",
    Address: "",
    LandArea: "",
    TotalFloors: "",
    TotalBlocks: "",
    TotalUnits: "",
    Construction_Status: "",
    Description: ""
  });
  const [owner, setOwner] = useState({
    owner_name: "",
    owner_mobile: "",
    owner_email: "",
    owner_address: "",
    reference_name: "",
    reference_mobile: ""
  });


  const [amenities, setAmenities] = useState([{ name: "" }]);
  const [successOpen, setSuccessOpen] = useState(false);
  const [commissionType, setCommissionType] = useState("percentage");
  const [commissionValue, setCommissionValue] = useState("");


  /* ================= FETCH DATA ================= */
  useEffect(() => {
    if (!apartmentId || !open) return;

    setLoading(true);
    investorApi
      .getApartmentPlotsById(apartmentId)
      .then((res) => {
      
        const { apartment, owner_details } = res.data;

        setForm({
          ApartmentName: apartment.ApartmentName || "",
          City: apartment.City || "",
          Address: apartment.Address || "",
          LandArea: apartment.LandArea || "",
          TotalFloors: apartment.TotalFloors || "",
          TotalBlocks: apartment.TotalBlocks || "",
          TotalUnits: apartment.TotalUnits || "",
          Construction_Status: apartment.Construction_Status || "",
          Description: apartment.Description || ""
        });

        if (apartment.PercentageAmount) {
          setCommissionType("percentage");
          setCommissionValue(apartment.PercentageAmount);
        } else if (apartment.SqftAmount) {
          setCommissionType("sqft");
          setCommissionValue(apartment.SqftAmount);
        } else {
          setCommissionValue("");
        }


        setAmenities(
          apartment.Amenities?.length
            ? apartment.Amenities.map((a) => ({ name: a.name }))
            : [{ name: "" }]
        );

        // OWNER DETAILS (take first object)
        if (owner_details?.length) {
          setOwner({
            owner_name: owner_details[0].owner_name || "",
            owner_mobile: owner_details[0].owner_mobile || "",
            owner_email: owner_details[0].owner_email || "",
            owner_address: owner_details[0].owner_address || "",
            reference_name: owner_details[0].reference_name || "",
            reference_mobile: owner_details[0].reference_mobile || ""
          });
        }
      })


      .finally(() => setLoading(false));
  }, [apartmentId, open]);

  /* ================= HANDLERS ================= */
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleOwnerChange = (e) => {
    setOwner({ ...owner, [e.target.name]: e.target.value });
  };


  const handleAmenityChange = (i, value) => {
    const updated = [...amenities];
    updated[i].name = value;
    setAmenities(updated);
  };

  const addAmenity = () => setAmenities([...amenities, { name: "" }]);
  const removeAmenity = (i) =>
    setAmenities(amenities.filter((_, idx) => idx !== i));

  /* ================= SUBMIT ================= */
  const updateApartment = async () => {
  try {
    const fd = new FormData();

    Object.entries(form).forEach(([k, v]) => fd.append(k, v));

    // COMMISSION
    // if (commissionType === "percentage") {
    //   fd.append("PercentageAmound", commissionValue);
    //   fd.append("SqftAmound", "");
    // } else {
    //   fd.append("SqftAmound", commissionValue);
    //   fd.append("PercentageAmound", "");
    // }

      fd.append("commissionType", commissionType);   // send type
    fd.append("CommissionValue", commissionValue);
    // AMENITIES
    fd.append(
      "Amenities",
      JSON.stringify(amenities.filter((a) => a.name.trim()))
    );

    // OWNER DETAILS
    Object.entries(owner).forEach(([k, v]) => fd.append(k, v));
for (let [key, value] of fd.entries()) {
  console.log(key, value);
}
debugger
    await vendorApi.editApartment(apartmentId, fd);

    setSuccessOpen(true);
    onUpdated();
    onClose();
  } catch (err) {
    console.error("Update error:", err);
  }
};


  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Edit Apartment Details</DialogTitle>

        <DialogContent dividers>
          {loading ? (
            <Box textAlign="center">
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField fullWidth label="Apartment Name" name="ApartmentName" value={form.ApartmentName} onChange={handleChange} />
              </Grid>

              <Grid item xs={6}>
                <TextField fullWidth label="City" name="City" value={form.City} onChange={handleChange} />
              </Grid>

              <Grid item xs={6}>
                <TextField fullWidth label="Land Area" name="LandArea" value={form.LandArea} onChange={handleChange} />
              </Grid>

              <Grid item xs={12}>
                <TextField fullWidth label="Address" name="Address" value={form.Address} onChange={handleChange} />
              </Grid>

              <Grid item xs={6}>
                <TextField fullWidth label="Total Floors" name="TotalFloors" value={form.TotalFloors} onChange={handleChange} />
              </Grid>

              <Grid item xs={6}>
                <TextField fullWidth label="Total Blocks" name="TotalBlocks" value={form.TotalBlocks} onChange={handleChange} />
              </Grid>

              <Grid item xs={6}>
                <TextField fullWidth label="Total Units" name="TotalUnits" value={form.TotalUnits} onChange={handleChange} />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Construction Status"
                  name="Construction_Status"
                  value={form.Construction_Status}
                  onChange={handleChange}
                >
                  <MenuItem value="Planning">Planning</MenuItem>
                  <MenuItem value="Under Construction">Under Construction</MenuItem>
                  <MenuItem value="Ready to Move">Ready to Move</MenuItem>
                </TextField>
              </Grid>
              {/* COMMISSION */}
              <Grid item xs={6}>
                <TextField
                  select
                  fullWidth
                  label="Commission Type"
                  value={commissionType}
                  onChange={(e) => {
                    setCommissionType(e.target.value);
                    setCommissionValue("");
                  }}
                >
                  <MenuItem value="percentage">Percentage (%)</MenuItem>
                  <MenuItem value="sqft">Per Sqft</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label={commissionType === "percentage" ? "Percentage Amount" : "Sqft Amount"}
                  value={commissionValue}
                  onChange={(e) => setCommissionValue(e.target.value)}
                  type="number"
                />
              </Grid>



              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Description"
                  name="Description"
                  value={form.Description}
                  onChange={handleChange}
                />
              </Grid>

              {/* AMENITIES */}
              {amenities.map((a, i) => (
                <Grid item xs={12} key={i}>
                  <Box display="flex" gap={1}>
                    <TextField
                      fullWidth
                      label={`Amenity ${i + 1}`}
                      value={a.name}
                      onChange={(e) => handleAmenityChange(i, e.target.value)}
                    />
                    {amenities.length > 1 && (
                      <IconButton color="error" onClick={() => removeAmenity(i)}>
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Box>
                </Grid>
              ))}

              <Grid item xs={12}>
                <Button onClick={addAmenity}>+ Add Amenity</Button>
              </Grid>

              {/* OWNER DETAILS */}
              <Grid item xs={12}>
                <Box mt={2}>
                  <strong>Owner Details</strong>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Owner Name"
                  name="owner_name"
                  value={owner.owner_name}
                  onChange={handleOwnerChange}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Owner Mobile"
                  name="owner_mobile"
                  value={owner.owner_mobile}
                  onChange={handleOwnerChange}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Owner Email"
                  name="owner_email"
                  value={owner.owner_email}
                  onChange={handleOwnerChange}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Owner Address"
                  name="owner_address"
                  value={owner.owner_address}
                  onChange={handleOwnerChange}
                />
              </Grid>

            </Grid>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={updateApartment}>
            Update Details
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={successOpen} autoHideDuration={3000} onClose={() => setSuccessOpen(false)}>
        <Alert severity="success">Apartment details updated!</Alert>
      </Snackbar>
    </>
  );
};

export default EditApartmentModal;
